export class Modal {
    constructor(element) {
        /** @var {HTMLElement} */
        this.root = element;
        this.closeBtn = this.root.querySelector('.modal-close');
        this.closeBtn.addEventListener('click', () => this.hide());
        Array.from(document.querySelectorAll(`[data-modal="#${this.root.id}"]`))
            .forEach(btn => btn.addEventListener('click', () => this.show()));
    }

    show() {
        this.toggle(true);
    }

    hide() {
        this.toggle(false);
    }

    toggle(visible) {
        this.root.classList.toggle('modal-visible', visible);
    }
}